import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const SizeLengthsPage = () => {
    const columns = [
        { key: 'value', label: 'HEIGHT', type: 'number', required: true, step: 0.1, min: 0 },
        { key: 'unit', label: 'Unit', type: 'text', required: true },
        { key: 'display_name', label: 'Display Name', type: 'text', required: true },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "size_lengths", title: "Door Heights", columns: columns, apiPath: "size_lengths" }));
};
export default SizeLengthsPage;
